// extracted by mini-css-extract-plugin
export default {"chip":"General_chip__xOJfQ"};